import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/* Utility for chaining classes with Tailwind conflict support */
export const cn = (...classes: ClassValue[]) => twMerge(clsx(...classes));
